import { h } from 'preact';
import { Spinner } from '@cube/blocks';
import style from './style';
import cx from 'classnames';

export default function WeatherSpinner(props) {
	return (
		<div class={cx(style.loading, props.class, style[props.displayMode])} style={props.style}>
			<div>
				<Spinner class={style.spinner} />
			</div>
		</div>
	);
}
